export const backgroundLight = '#FFFFFF';

const palleteLight = colors => ({
  // default material-ui pallete use:
  type: 'light',
  primary: {
    main: colors.primary,
  },
  secondary: {
    main: '#5C5C5C',
  },
  error: {
    main: colors.negative,
  },
  text: {
    primary: 'rgba(0,0,0, .87)',
    secondary: 'rgba(0,0,0, .60)',
    hint: 'rgba(0,0,0, .38)',
    disabled: 'rgba(0,0,0, .26)',
  },
  // custom user pallete for components:
  custom: {
    background: {
      app: '#F2F2F2',
      area: backgroundLight,
    },
    surface: [
      'rgba(0,0,0, .02)',
      'rgba(0,0,0, .04)',
      'rgba(0,0,0, .06)',
      'rgba(0,0,0, .12)',
      'rgba(0,0,0, .16)',
    ],
    feedback: {
      positive: colors.positive,
      negative: colors.negative,
      warning: colors.warning,
    },
  },
});

export default palleteLight;
